var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email 1",
    clipPath: "url(#clip0_287_24041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.1786 30.6341C27.9347 31.4634 26.4897 31.9017 25 31.9017C23.5104 31.9017 22.0654 31.4634 20.8215 30.6341L0.33291 16.9746C0.219238 16.8988 0.108496 16.8198 0 16.7386V39.1211C0 41.6873 2.08252 43.7239 4.60283 43.7239H45.3971C47.9633 43.7239 49.9999 41.6414 49.9999 39.1211V16.7385C49.8912 16.8199 49.7803 16.8991 49.6663 16.975L29.1786 30.6341Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.95801 14.5369L22.4466 28.1965C23.2222 28.7136 24.111 28.9721 24.9999 28.9721C25.8889 28.9721 26.7778 28.7135 27.5534 28.1965L48.042 14.5369C49.2681 13.72 50 12.3529 50 10.8773C50 8.34006 47.9358 6.276 45.3987 6.276H4.60127C2.06416 6.2761 0 8.34016 0 10.8797C0 12.3529 0.732031 13.72 1.95801 14.5369Z",
    fill: "#52682F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_24041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSmall);
export default __webpack_public_path__ + "static/media/email-small.abc635354755b6c8ffe40d2cc0507438.svg";
export { ForwardRef as ReactComponent };